import updateApolloList from './updateApolloList';

export default function updateSubscribedList(
  listPath: string,
  itemKey: string,
  add?: boolean,
) {
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    prev: any,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    { subscriptionData: { data } }: { subscriptionData: { data: any } },
  ) => {
    return updateApolloList(prev, data, listPath, itemKey, add);
  };
}
